import { getCountry, getMerchant, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { isDemonstrationMerchant } from '@tectonics/prs/merchant';

function useMerchantInfo(): { isDemoMerchant: boolean, isPeru: boolean } {
  const incomingPayment = useIncomingPayment();
  const merchant = getMerchant(incomingPayment);
  const isDemoMerchant = isDemonstrationMerchant(merchant);
  const isPeru = getCountry(incomingPayment) === 'pe';

  return { isDemoMerchant, isPeru };
}

export { useMerchantInfo };
